module.exports = __webpack_public_path__ + "static/media/window-restore.1103f496.svg";